export default "__VITE_PUBLIC_ASSET__934e4457__"